import googleMapActionType from "./GoogleMap/actionType";
import assetsActionType from "./Assets/actionType";
import formActionType from "./Form/actionType";
import configActionType from "./Config/actionType";

const actionType = {
    googleMap: googleMapActionType,
    assets: assetsActionType,
    form: formActionType,
    config: configActionType,
};


export default actionType